// extracted by mini-css-extract-plugin
export default {"vehicleWrapper":"styles_vehicleWrapper__uyB19","imageWrapper":"styles_imageWrapper__b54Z4","description":"styles_description__tH4Hh"};